import { render } from "./dpw-table.vue?vue&type=template&id=620d5c6e&scoped=true"
import script from "./dpw-table.vue?vue&type=script&lang=js"
export * from "./dpw-table.vue?vue&type=script&lang=js"

import "./dpw-table.vue?vue&type=style&index=0&id=620d5c6e&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-620d5c6e"]])

export default __exports__